import { gsap } from 'gsap';

class LineUpTabs {
    constructor(container) {
        this.container = container;
        this.navigation = null;
        this.navigationItems = [];
        this.chaser = null;
        this.track = null;
        this.days = [];
        this.current = 0;

        this.getElements();

        if (this.canInit()) {
            this.setEvents();
        }
    }

    /**
     * 
     */
    getElements() {
        this.navigation = this.container.querySelector('.line-up-nav');
        this.navigationArrows = this.container.querySelectorAll('.line-up-nav__item--arrow');
        this.navigationItems = this.container.querySelectorAll('.line-up-nav__item--default');
        this.chaser = this.container.querySelector('.line-up-nav__chaser');
        this.track = this.container.querySelector('.line-up-days__track');
        this.days = this.container.querySelectorAll('.line-up-day');
    }

    /**
     * 
     */
    canInit() {
        return this.navigation !== null && this.navigationItems.length > 0 && this.chaser !== null && this.track !== null && this.days.length > 0;
    }

    /**
     * 
     */
    setEvents() {
        this.setNavigationItemEvents();
    }

    /**
     * 
     */
    setNavigationItemEvents() {
        this.navigationArrows.forEach((item) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                this.handleNavigationItemMobileClick(item);
            });
        });

        this.navigationItems.forEach((item, index) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                this.handleNavigationItemClick(item, index);
            });
        });
    }

    /**
     * 
     * @param Node item 
     * @param number index 
     */
    handleNavigationItemMobileClick(item, index) {

        const isNext = item.dataset.next !== undefined;

        if (isNext) {
            this.current = (this.current < 2) ? this.current + 1 : 2;
        } else {
            this.current = (this.current > 0) ? this.current - 1 : 0;
        }

        this.newActive = this.navigationItems[this.current];

        this.getNewActive(this.newActive);
        LineUpTabs.handleNavTrack(this.current);
        this.handleTrack(this.current);
        this.handleTrackItems(this.current);
    }

    /**
     * 
     * @param Node item 
     * @param number index 
     */
    handleNavigationItemClick(item, index) {

        this.getNewActive(item);
        this.handleChaser(item);
        this.handleTrack(index);
        this.handleTrackItems(index);
    }

    getNewActive(item){
        this.navigationItems.forEach(child => {
            child.classList.remove('is-active');
        })

        item.classList.add('is-active');
    }

    /**
     * 
     * @param Node item 
     */
    handleChaser(item) {
        const left = item.offsetLeft;
        const position = left;

        gsap.to(this.chaser, {
            x: position,
            duration: 0.5,
            ease: "power2.out",
        });
    }

    /**
     * 
     * @param number index 
     */
    static handleNavTrack(index) {
        const track = document.querySelector('.line-up-nav__inner');

        if (track !== null) {
            const offset = -100 / 3
            const position = `${(index) * offset}%`;

            gsap.to(track, {
                x: position,
                duration: 0.5,
                ease: "power2.out",
            });
        }
    }

    /**
     * 
     * @param number index 
     */
    handleTrack(index) {
        const offset = -100 / this.navigationItems.length
        const position = `${index * offset}%`;

        gsap.to(this.track, {
            x: position,
            duration: 0.5,
            ease: "power2.out",
        });
    }

    /**
     * 
     * @param number index 
     */
    handleTrackItems(index) {
        gsap.to(this.days, {
            opacity: 0,
            duration: 0.3,
            ease: "power2.out",
        });

        gsap.to(this.days[index], {
            opacity: 1,
            duration: 0.3,
            ease: "power2.out",
        });
    }
}

function initLineUpTabs() {
    const sections = document.querySelectorAll('.line-up-section');

    sections.forEach(section => {
        // eslint-disable-next-line no-new
        new LineUpTabs(section);
    });
}

initLineUpTabs();